import React, { useState } from "react";
import moment from "moment";

import styles from "./billsPaymentDetailCard.module.css";
export const BillsPaymentDetailCard = ({
  po_number,
  po_date,
  bill_date,
  bill_number,
  bill_amount,
  gross_amount,
  status,
  po_display_number,
  po_title,
}) => {
  const [show, setShow] = useState(true);

  return (
    <div>
      <div className={styles.basicInfoDivPOCard}>
        <div className={styles.BasicInfoTopPOCard}>
          <div className={styles.basicInfoTopImgPOCard}>
            <div>
              <img src="./images/stratum/basicDetails.svg" alt="" />
            </div>
            <h6>General Info</h6>
          </div>

          <img
            src="/images/upArrow.png"
            className={!show && styles.rotateSvg}
            alt=""
            onClick={() => setShow(!show)}
          />
        </div>

        {show && (
          <>
            <div className={styles.basicInfoDetailPOCard}>
              <span>
                <p>PO NO</p>
                <p>{po_display_number ? po_display_number : "-"}</p>
              </span>

              <span>
                <p>PO TITLE</p>
                <p>{po_title ? po_title : "-"}</p>
              </span>
              <span>
                <p>PO DATE</p>
                <p>{po_date ? moment(po_date).format("DD MMM YYYY") : "-"}</p>
              </span>
            </div>
            <div className={styles.basicInfoDetailPOCard}>
              <span>
                <p>BILL NO</p>
                <p>{bill_number ? bill_number : "-"}</p>
              </span>
              <span>
                <p>BILL DATE</p>
                <p> {moment(bill_date).format("DD MMM YYYY")}</p>
              </span>
              <span>
                <p>AMOUNT</p>
                <p>{`${gross_amount ? gross_amount : "-"} AED`}</p>
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
